module.exports = __webpack_public_path__ + "img/logo.5f8ce749.png";